// Generated by ReScript, PLEASE EDIT WITH CARE


function englishCampaign(state) {
  var target = state.target;
  var param_current_value = state.param_current_value;
  return {
          criteria: "" + param_current_value + " of " + target + " trips completed",
          viewPerformance: "View Performance",
          validatorCompleted: "" + param_current_value + " trips completed",
          progressTitle: "Trip incentive in progress",
          completeTarget: "Target: " + target,
          validatorMissed: "" + state.validatorMissed + " missed orders",
          missedTarget: "Number of missed orders allowed: " + state.missedTarget,
          validatorABRTG: "" + state.validatorABRTG + " ABRTG orders",
          abrtgTarget: "Number of ABRTG orders allowed: " + state.abrtgTarget,
          froudOrders: "Fraud orders done",
          noFraudORders: "No Fraud orders done",
          fraudOrdersAllowed: "Number of fraud orders allowed: " + state.fraudOrdersAllowed,
          completedTitle: "Trip incentive completed",
          disqualifiedTitle: "Disqualified from trip incentive",
          trips: "Trips",
          amount: "Amount"
        };
}

var English = {
  englishCampaign: englishCampaign
};

function hindiCampaign(state) {
  var target = state.target;
  var param_current_value = state.param_current_value;
  return {
          criteria: "" + target + " में से " + param_current_value + " ट्रिप पूरी हुई",
          viewPerformance: "प्रदर्शन देखें",
          validatorCompleted: "" + param_current_value + " यात्राएं पूरी हुई",
          progressTitle: "ट्रिप प्रोत्साहन प्रगति पर",
          completeTarget: "लक्ष्य: " + target,
          validatorMissed: "" + state.validatorMissed + " छूटे हुए आर्डर ",
          missedTarget: "छूटे हुए आदेशों की संख्या की अनुमति है: " + state.missedTarget,
          validatorABRTG: "" + state.validatorABRTG + " एबीआरटीजी आदेश",
          abrtgTarget: "अनुमत एबीआरटीजी आदेशों की संख्या: " + state.abrtgTarget,
          froudOrders: "",
          noFraudORders: "",
          fraudOrdersAllowed: "अनुमत धोखाधड़ी आदेशों की संख्या: " + state.fraudOrdersAllowed,
          completedTitle: "ट्रिप प्रोत्साहन पूरी हुई",
          disqualifiedTitle: "ट्रिप प्रोत्साहन से अयोग्य",
          trips: "ट्रिप्स",
          amount: "राशि"
        };
}

var Hindi = {
  hindiCampaign: hindiCampaign
};

function kannadaCampaign(state) {
  var target = state.target;
  var param_current_value = state.param_current_value;
  return {
          criteria: "" + param_current_value + " ಟ್ರಿಪ್‌ಗಳಲ್ಲಿ " + target + " ಪೂರ್ಣಗೊಂಡಿದೆ",
          viewPerformance: "ಕಾರ್ಯಕ್ಷಮತೆಯನ್ನು ವೀಕ್ಷಿಸಿ",
          validatorCompleted: "" + param_current_value + " ಟ್ರಿಪ್‌ಗಳು ಪೂರ್ಣಗೊಂಡಿವೆ",
          progressTitle: "ಟ್ರಿಪ್ ಇನ್ಸೆಂಟಿವ್ಸ್  ಚಾಲ್ತಿಯಲ್ಲಿದೆ",
          completeTarget: "ಗುರಿ: " + target,
          validatorMissed: "" + state.validatorMissed + " ಮಿಸ್ಡ್ ಆರ್ಡರ್ಸ್",
          missedTarget: "ಅನುಮತಿಸಲಾದ ಮಿಸ್ಡ್ ಆರ್ಡರ್‌ಗಳ ಸಂಖ್ಯೆ: " + state.missedTarget,
          validatorABRTG: "" + state.validatorABRTG + " ABRTG ಆರ್ಡರ್ ಗಳು",
          abrtgTarget: "ಅನುಮತಿಸಲಾದ ABRTG ಆರ್ಡರ್‌ಗಳ ಸಂಖ್ಯೆ: " + state.abrtgTarget,
          froudOrders: "ಫ್ರಾಡ್ ಆರ್ಡರ್ ಗಳನ್ನು ಮಾಡಲಾಗಿದೆ",
          noFraudORders: "ಯಾವುದೇ ಫ್ರಾಡ್ ಆರ್ಡರ್ ಗಳನ್ನು ಮಾಡಲಾಗಿಲ್ಲ",
          fraudOrdersAllowed: "ಅನುಮತಿಸಲಾದ ಫ್ರಾಡ್  ಆರ್ಡರ್ ಗಳ ಸಂಖ್ಯೆ: " + state.fraudOrdersAllowed,
          completedTitle: "ಟ್ರಿಪ್ ಇನ್ಸೆಂಟಿವ್ಸ್  ಪೂರ್ಣಗೊಂಡಿದೆ",
          disqualifiedTitle: "ಟ್ರಿಪ್ ಇನ್ಸೆಂಟಿವ್ಸ್ ನಿಂದ  ಅನರ್ಹಗೊಳಿಸಲಾಗಿದೆ",
          trips: "ಟ್ರಿಪ್ಸ್",
          amount: "ಮೊತ್ತ"
        };
}

var Kannada = {
  kannadaCampaign: kannadaCampaign
};

function marathiCampaign(state) {
  var target = state.target;
  var param_current_value = state.param_current_value;
  return {
          criteria: "" + target + " पैकी " + param_current_value + " ट्रिप पूर्ण झाल्या",
          viewPerformance: "कामगिरी पहा",
          validatorCompleted: "" + param_current_value + " ट्रिप पूर्ण झाल्या",
          progressTitle: "ट्रिप इन्सेन्टिव्ह प्रगतीपथावर आहे",
          completeTarget: "टार्गेट: " + target,
          validatorMissed: "" + state.validatorMissed + " मिस झालेल्या ऑर्डर्स",
          missedTarget: "परवानगी असलेल्या मिस ऑर्डरची संख्या: " + state.missedTarget,
          validatorABRTG: "" + state.validatorABRTG + " ABRTG ऑर्डर",
          abrtgTarget: "परवानगी असलेल्या ABRTG ऑर्डरची संख्या: " + state.abrtgTarget,
          froudOrders: "",
          noFraudORders: "",
          fraudOrdersAllowed: "परवानगी असलेल्या फ्रॉड ऑर्डरची संख्या: " + state.fraudOrdersAllowed,
          completedTitle: "ट्रिप इन्सेन्टिव्ह पूर्ण झाले",
          disqualifiedTitle: "ट्रिप इन्सेन्टिव्ह पासून अपात्र",
          trips: "ट्रिप्स",
          amount: "रक्कम"
        };
}

var Marathi = {
  marathiCampaign: marathiCampaign
};

function tamilCampaign(state) {
  var target = state.target;
  var param_current_value = state.param_current_value;
  return {
          criteria: "" + target + " இல் " + param_current_value + " சவாரி முடிக்கப்பட்டுள்ளது",
          viewPerformance: "செயல்பாட்டை பார்க்க ",
          validatorCompleted: "" + param_current_value + " சவாரிகள் முடிக்கப்பட்டுள்ளது",
          progressTitle: "சவாரிக்கான இன்சென்டிவ் சரிபார்ப்பு நிலையில் உள்ளது",
          completeTarget: "இலக்கு: " + target,
          validatorMissed: "" + state.validatorMissed + " தவற விட்ட சவாரிகள்",
          missedTarget: "அனுமதிக்கப்படும் தவறவிட்ட ஆர்டர்களின் எண்ணிக்கை: " + state.missedTarget,
          validatorABRTG: "" + state.validatorABRTG + " ரத்து செய்த சவாரி ",
          abrtgTarget: "அனுமதிக்கப்பட்ட ABRTG ஆர்டர்களின் எண்ணிக்கை: " + state.abrtgTarget,
          froudOrders: "பிராடு ஆர்டர்கள் செய்யப்பட்டுள்ளன",
          noFraudORders: "பிராடு ஆர்டர்கள் செய்யப்படவில்லை",
          fraudOrdersAllowed: "அனுமதிக்கப்பட்ட பிராட் ஆர்டர்களின் எண்ணிக்கை: " + state.fraudOrdersAllowed,
          completedTitle: "சவாரிக்கான இன்சென்டிவ் முடிக்கப்பட்டுள்ளது ",
          disqualifiedTitle: "இன்சென்டிவிலிருந்து தகுதி நீக்கம் ",
          trips: "சவாரிகள் ",
          amount: "தொகை"
        };
}

var Tamil = {
  tamilCampaign: tamilCampaign
};

function teluguCampaign(state) {
  var target = state.target;
  var param_current_value = state.param_current_value;
  return {
          criteria: "" + target + " లో " + param_current_value + " ట్రిప్ లు పూర్తి అయ్యాయి",
          viewPerformance: "పనితీరును చూడండి",
          validatorCompleted: "" + param_current_value + " ట్రిప్స్ పూర్తయ్యాయి",
          progressTitle: "ట్రిప్ ఇన్సెంటివ్స్  పురోగతిలో ఉంది",
          completeTarget: "లక్ష్యం: " + target,
          validatorMissed: "" + state.validatorMissed + " తప్పిన ఆర్డర్లు",
          missedTarget: "తప్పిన ఆర్డర్‌ల సంఖ్య అనుమతించబడింది: " + state.missedTarget,
          validatorABRTG: "" + state.validatorABRTG + " abrtg ఆర్డర్లు",
          abrtgTarget: "అనుమతించబడిన ABRTG ఆర్డర్‌ల సంఖ్య: " + state.abrtgTarget,
          froudOrders: "ఫ్రాడ్ ఆర్డర్లు చేశారు",
          noFraudORders: "ఎలాంటి మోసపూరిత ఆర్డర్లు చేయలేదు",
          fraudOrdersAllowed: "అనుమతించబడిన మోసపూరిత ఆర్డర్‌ల సంఖ్య: " + state.fraudOrdersAllowed,
          completedTitle: "ట్రిప్ ఇన్సెంటివ్స్లు పూర్తయ్యాయి",
          disqualifiedTitle: "ట్రిప్ ఇన్సెంటివ్స్ నుండి తొలగించుబడరు",
          trips: "ట్రిప్",
          amount: "అమౌంట్"
        };
}

var Telugu = {
  teluguCampaign: teluguCampaign
};

function banglaCampaign(state) {
  var target = state.target;
  var param_current_value = state.param_current_value;
  return {
          criteria: "" + param_current_value + " টি " + target + " trips সম্পন্ন",
          viewPerformance: "পারফরম্যান্স দেখুন",
          validatorCompleted: "" + param_current_value + " ট্রিপ টি  সম্পন্ন হয়েছে",
          progressTitle: "ট্রিপ ইনসেন্টিভ চলমান",
          completeTarget: "লক্ষ্য: " + target,
          validatorMissed: "" + state.validatorMissed + " মিস করা অর্ডার",
          missedTarget: "অনুমোদিত মিস অর্ডারের সংখ্যা: " + state.missedTarget,
          validatorABRTG: "" + state.validatorABRTG + " এবিআরটিজি অর্ডার",
          abrtgTarget: "অনুমোদিত এবিআরটিজি অর্ডারের সংখ্যা: " + state.abrtgTarget,
          froudOrders: "ফ্রড অর্ডার সম্পন্ন",
          noFraudORders: "কোন ফ্রড অর্ডার সম্পন্ন নয়",
          fraudOrdersAllowed: "ফ্রড অর্ডারের অনুমোদিত সংখ্যা: " + state.fraudOrdersAllowed,
          completedTitle: "ট্রিপ ইনসেন্টিভ সম্পন্ন",
          disqualifiedTitle: "ট্রিপ ইনসেন্টিভ থেকে বাদ প্রাপ্ত",
          trips: "ট্রিপস",
          amount: "পরিমাণ"
        };
}

var Bangla = {
  banglaCampaign: banglaCampaign
};

export {
  English ,
  Hindi ,
  Kannada ,
  Marathi ,
  Tamil ,
  Telugu ,
  Bangla ,
  
}
/* No side effect */
